<template>
    <CModal
        size="xl"
        alignment="center"
        :visible="showModal"
        @close="closeEventModal"
    >
        <CModalHeader>
            <CModalTitle
                >{{ $t('general.notificationInfo') }} :
                {{ $t(`general.${eventType}`) }}</CModalTitle
            >
        </CModalHeader>

        <CModalBody>
            <CForm v-if="eventType == 'vacation' || eventType == 'dayOff'">
                <div class="mb-3">
                    <p>
                        {{ $t('tasks.createTask.worker') }} :
                        {{ eventData.user.user_name }}
                    </p>
                </div>

                <div class="mb-3">
                    <p>
                        {{ $t('vacation.tableCols.paid') }}:
                        {{
                            eventData.without_pay
                                ? $t('general.yes')
                                : $t('general.no')
                        }}
                    </p>
                </div>

                <div class="mb-3">
                    <p>
                        {{ $t('vacation.tableCols.status') }} :
                        <span :class="`${eventData.active}`">
                            {{
                                eventData.active === 'approved'
                                    ? $t('vacation.approved')
                                    : eventData.active === 'pending'
                                    ? $t('vacation.pending')
                                    : $t('vacation.notApproved')
                            }}</span
                        >
                    </p>
                </div>

                <div class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateBeginning')
                    }}</CFormLabel>
                    <input
                        type="date"
                        ref="date"
                        :value="eventData.start"
                        disabled
                        class="date-input"
                    />
                </div>

                <div class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateEnding')
                    }}</CFormLabel>
                    <input
                        type="date"
                        ref="date"
                        :value="eventData.end"
                        disabled
                        class="date-input"
                    />
                </div>
            </CForm>

            <CForm v-if="eventType == 'birthday'">
                <div class="mb-3">
                    <div class="mb-3">
                        <p>
                            {{ $t('tasks.createTask.worker') }} :
                            {{ eventData.user }}
                        </p>
                    </div>

                    <div class="mb-3">
                        <p>
                            {{ $t('general.age') }} :
                            {{ eventData.age }}
                        </p>
                    </div>

                    <div class="mb-3">
                        <CFormLabel>{{
                            $t('notification.birthday')
                        }}</CFormLabel>
                        <input
                            type="date"
                            ref="date"
                            :value="eventData.birthday"
                            disabled
                            class="date-input"
                        />
                    </div>
                </div>
            </CForm>

            <CForm v-if="eventType == 'hr_meeting'">
                <div class="mb-3">
                    <p>
                        {{ $t('tasks.createTask.worker') }} :
                        {{ eventData.client.user_name }}
                    </p>
                </div>

                <div class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateBeginning')
                    }}</CFormLabel>
                    <input
                        disabled
                        type="datetime-local"
                        :value="eventData.start"
                        class="date-input"
                    />
                </div>

                <div class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateEnding')
                    }}</CFormLabel>
                    <input
                        disabled
                        type="datetime-local"
                        :value="eventData.end"
                        class="date-input"
                    />
                </div>
            </CForm>

            <CForm v-if="eventType == 'candidate_meeting'">
                <div class="mb-3">
                    <p>
                        {{ $t('hr.candidate') }} : {{ eventData.first_name }}
                        {{ eventData.last_name }}
                    </p>
                </div>

                <div class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateBeginning')
                    }}</CFormLabel>
                    <input
                        disabled
                        type="datetime-local"
                        :value="eventData.start"
                        class="date-input"
                    />
                </div>

                <div class="mb-3">
                    <CFormLabel>{{
                        $t('calendar.form.dateEnding')
                    }}</CFormLabel>
                    <input
                        disabled
                        type="datetime-local"
                        :value="eventData.end"
                        class="date-input"
                    />
                </div>
            </CForm>
        </CModalBody>

        <CModalFooter>
            <CButton
                color="primary"
                size="sm"
                @click="goToDate(eventData.start)"
            >
                {{ $t('general.seeInCalendar') }}
            </CButton>
            <CButton
                v-if="
                    eventData.active !== 'approved' &&
                    (eventData.type === 'Vacation' ||
                        eventData.type === 'DayOff')
                "
                @click="approveVacation"
                size="sm"
                color="primary"
                >{{ $t('getVacation.form.approve') }}</CButton
            >
            <CButton
                v-if="
                    eventData.active !== 'rejected' &&
                    (eventData.type === 'Vacation' ||
                        eventData.type === 'DayOff')
                "
                @click="rejectVacation"
                size="sm"
                color="primary"
                >{{ $t('getVacation.form.reject') }}</CButton
            >


        </CModalFooter>
    </CModal>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import '@vuepic/vue-datepicker/dist/main.css'
import fireSwal from '@/helpers/fireSwal'
import getRouteForNotificationLink from '@/helpers/getRouteForNotificationLink'


export default {
    name: 'Event Modal',
    components: {},
    emits: ['showEvent', 'closeEventModal'],
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        eventType: {
            type: String,
            required: true,
        },
        eventData: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const store = useStore()
        const state = reactive({})

        return { ...toRefs(state), store }
    },
    methods: {
        closeEventModal() {
            this.$emit('closeEventModal', false)
        },

      goToDate(date) {
            const route = getRouteForNotificationLink(this.eventType);
            const { href } = this.$router.resolve({
                path: `/hr/${route}/${date}`,
            })

            window.open(href, '_blank')
        },
        approveVacation() {
            this.closeEventModal()

            this.$store
                .dispatch(`hr/approve${this.eventData.type}`, {
                    eventId: this.eventData.id,
                    form: {
                        active: 'approved',
                    },
                })
                .then(() => {
                    fireSwal(
                        this.$t(
                            `notification.${this.eventData.type}IsApproved`,
                        ),
                        'success',
                    )
                })
        },
        rejectVacation() {
            this.closeEventModal()

            this.$store
                .dispatch(`hr/approve${this.eventData.type}`, {
                    eventId: this.eventData.id,
                    form: {
                        active: 'rejected',
                    },
                })
                .then(() => {
                    fireSwal(
                        this.$t(
                            `notification.${this.eventData.type}IsRejected`,
                        ),
                        'success',
                    )
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.pending {
    color: orange;
}

.approved {
    color: green;
}

.notApproved {
    color: red;
}
</style>
